/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heroic_Mean_Hedgehog_ApproveInputs */

const fr_heroic_mean_hedgehog_approve = /** @type {(inputs: Heroic_Mean_Hedgehog_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les types`)
};

/**

* @param {Heroic_Mean_Hedgehog_ApproveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const heroic_mean_hedgehog_approve = /** @type {((inputs?: Heroic_Mean_Hedgehog_ApproveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heroic_Mean_Hedgehog_ApproveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_heroic_mean_hedgehog_approve(inputs)
});